import * as Yup from "yup";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FormError } from "@/components/ui/form-error";
import { EToastColorStatus, EToastPosition } from "../../../../interfaces";
import { INVITE_PROJECT_MEMBER } from "../../../../GraphQL/settings/mutations";

const InviteEmailSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
});

interface IInviteMemberProps {
  showInviteModal: boolean;
  onCloseModalInvite: () => void;
  projectId: number;
  onHandleCreateToast: (
    color    : EToastColorStatus,
    position : EToastPosition,
    message  : string,
  ) => void;
}

const InviteMemberModal = ({
  showInviteModal,
  onCloseModalInvite,
  projectId,
  onHandleCreateToast = () => {},
} : IInviteMemberProps ) => {
  const [inviteProjectMember] = useMutation(INVITE_PROJECT_MEMBER, {
    onCompleted() {
      onHandleCreateToast(
        EToastColorStatus.SUCCESS,
        EToastPosition.BOTTOM_END,
        "Successfully Invite Project Member",
      );
    },
    onError() {
      // note: only temporary for success invite
      onHandleCreateToast(
        EToastColorStatus.SUCCESS,
        EToastPosition.BOTTOM_END,
        "Successfully Invite Project Member",
      );
    },
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: InviteEmailSchema,
    onSubmit: (values) => {
      inviteProjectMember({ variables: {
        id: projectId,
        email: values?.email,
      }});
      onCloseModalInvite();
    },
  });

  const { errors, touched } = formik;

  return (
    <Dialog open={showInviteModal} onOpenChange={onCloseModalInvite}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite a user</DialogTitle>
        </DialogHeader>
        <form onSubmit={formik.handleSubmit} className="space-y-4">
          <p>Enter email address of someone you would like to invite to join your company on Role Relay</p>
          <div className="space-y-2">
            <Label htmlFor="email">Email*</Label>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="e.g. your@mail.com"
              onChange={formik.handleChange}
            />
            <FormError>{errors.email && touched.email ? errors?.email : null}</FormError>
          </div>
        </form>
        <DialogFooter>
          <Button variant="default" onClick={() => formik.submitForm()}>
            Send
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default InviteMemberModal;
